<template>
  <el-dialog :visible.sync="value" width="600px" :title="'使用手机端' + (code ? '(接入码 ' + code + ')' : '')">
    <div slot="title">
      使用手机端(<span style="color: #FF7062">{{ code ? "接入码: " + code : "" }}</span>)
    </div>
    <div class="modalType">
      <!-- app二维码 -->
      <div class="app-code">
        <img src="/static/img/app-download.png" style="width:200px;height:auto" alt="">
        <p style="font-weight:bold">海纳视频面试 App</p>
        <p>扫码下载</p>
      </div>
      <div class="mini-code">
        <img src="/static/img/wechatHina.jpg" style="width:200px;height:auto"/>
        <p style="text-align:center;font-weight:bold">微信小程序</p>
        <p style="text-align:center">扫码进入</p>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import Clipboard from 'clipboard'

export default {
  name: 'ToMpModal',
  props: {
    code: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      value: false,
    }
  },
  methods: {
    show () {
      this.value = true
    },

    copy (url) {
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      oInput.style.display = 'none'
      document.body.removeChild(oInput)
      this.$message.success('复制链接成功')
    },
    copyLink () {
      this.copy('https://oss.hinapower.cn/cdn/app/hina/page/appdown.html')
    },
  },
}
</script>

<style scoped lang="scss">

.modalType {
  width: 100%;
  display: flex;
  // align-items: center;
  justify-content: center;
}

.modalType img {
  margin-bottom: 20px;
}

.modalType p {
  margin: 4px 0;
}

.mini-code {
  margin-left: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.app-code {
  margin-right: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  img {
    width: 100px;
    height: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ToMpModal.vue